import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useAuth } from '@/shared/auth';
import type { PromotionalRoGrantData } from '@/entities/notification';
import { getGrantCopyKeys } from '../model/getGrantCopyKeys';

interface Props {
  open: boolean;
  data: PromotionalRoGrantData | null;
  onClose: () => void;
}

export const PromotionalGrantModal = ({ open, data, onClose }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { sessionUser } = useAuth();

  const reason = data?.reason ?? 'default';
  const amount = data?.amount ?? 0;
  const newAllowance = data?.newAllowance ?? 0;
  const used = sessionUser?.subscription.freeRosUsed ?? 0;
  const remaining = Math.max(0, newAllowance - used);

  const { headline, body } = getGrantCopyKeys(reason);

  const handleSeeUsage = () => {
    onClose();
    navigate('/settings/subscription');
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth aria-labelledby="promotional-grant-title">
      <DialogTitle id="promotional-grant-title">{t(headline, { amount })}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t(body, { amount, remaining, newAllowance })}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSeeUsage} color="inherit">
          {t('subscription.promotionalGrant.secondaryCta')}
        </Button>
        <Button onClick={onClose} variant="contained" color="primary">
          {t('subscription.promotionalGrant.primaryCta')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
